"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_PATH = exports.DEFAULT_PROJECT_ID = exports.DEFAULT_ROOT_ID = void 0;
exports.DEFAULT_ROOT_ID = 'root';
exports.DEFAULT_PROJECT_ID = 'mb-ui';
exports.BASE_PATH = '/';
//# sourceMappingURL=index.js.map